export const styles = {
  optionsWrapper: {
    width: '208px',
    position: 'absolute',
    background: '#FFFFFF',
    borderRadius: '8px',
    border: '1px solid #2737541F',
    marginTop: '4px',
    zIndex: 2,
    '& > div': {
      padding: '13px 10px',
      lineHeight: '18px',
      cursor: 'default',
      color: '#0C172C',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      '&:hover': {
        '&:first-child': {
          borderRadius: '8px 8px 0 0',
        },
        background: '#E2E2FC',
        cursor: 'pointer',
        '&:last-child': {
          borderRadius: '0 0 8px 8px',
        },
      },
    },
  },
  label: {
    border: '1px solid #E2E2FC',
    borderRadius: '12px',
    background: '#F9F9FF',
    padding: '4px 8px',
    color: '#4F5B94',
    fontSize: '12px',
  },
}
